// extracted by mini-css-extract-plugin
export default {"datasetRoutes":"datasetRoutes-wdJF_","routeErrorContainer":"routeErrorContainer-VyYSk"};